import * as Types from '../../generated.types'

import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { fetchGql } from '@alice-financial/api'
export type EmployeeUpcomingPaycheckQueryVariables = Types.Exact<{
  employeeId: Types.Scalars['Int']
}>

export type EmployeeUpcomingPaycheckQuery = {
  __typename?: 'Query'
  employee?: {
    __typename?: 'Employee'
    id: number
    upcomingPaycheck?: {
      __typename?: 'UpcomingPaycheck'
      massTransitDeduction: number
      massTransitReimbursement: number
      parkingDeduction: number
      parkingReimbursement: number
    } | null
  } | null
}

export const EmployeeUpcomingPaycheckDocument = `
    query EmployeeUpcomingPaycheck($employeeId: Int!) {
  employee(id: $employeeId) {
    id
    upcomingPaycheck {
      massTransitDeduction
      massTransitReimbursement
      parkingDeduction
      parkingReimbursement
    }
  }
}
    `
export const useEmployeeUpcomingPaycheckQuery = <TData = EmployeeUpcomingPaycheckQuery, TError = Error>(
  variables: EmployeeUpcomingPaycheckQueryVariables,
  options?: UseQueryOptions<EmployeeUpcomingPaycheckQuery, TError, TData>
) =>
  useQuery<EmployeeUpcomingPaycheckQuery, TError, TData>(
    ['EmployeeUpcomingPaycheck', variables],
    fetchGql<EmployeeUpcomingPaycheckQuery, EmployeeUpcomingPaycheckQueryVariables>(
      EmployeeUpcomingPaycheckDocument,
      variables
    ),
    options
  )

useEmployeeUpcomingPaycheckQuery.getKey = (variables: EmployeeUpcomingPaycheckQueryVariables) => [
  'EmployeeUpcomingPaycheck',
  variables,
]
